import { render } from "./ModalCadastro.vue?vue&type=template&id=0dcb46e8"
import script from "./ModalCadastro.vue?vue&type=script&async=true&lang=js"
export * from "./ModalCadastro.vue?vue&type=script&async=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__